import styled from "@emotion/styled";

export const NavWrapper = styled.div`
    display: flex;
    align-items: center;
`